import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/users/expedition/new',
  title: 'Cadastrar Expedição',
  endpoint: '/app/person',
}
